import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals } from 'helpers'

import Button from 'components/ui/Button/Button'
import Modal from 'components/Modal/Modal'
import Box from 'components/layout/Box/Box'

import s from './DialogModal.scss'


class DialogModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.Dialog,
  }

  close = () => {
    const { name, data: { onClose } } = this.props

    actions.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  handleButtonClick = () => {
    const { data: { onButtonClick } } = this.props

    this.close()

    if (typeof onButtonClick === 'function') {
      onButtonClick()
    }
  }

  render() {
    const { data: { title, text, buttonTitle, content } } = this.props

    return (
      <Modal onClose={this.close}>
        <div>
          <div className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
          {
            Boolean(text) && (
              <Box pt={16}>
                <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
              </Box>
            )
          }
          {
            Boolean(content) ? (
              <Box pt={16}>{content({ close: this.close })}</Box>
            ) : (
              <Button
                className={s.button}
                title={buttonTitle || 'Ок'}
                green
                fullWidth
                onClick={this.handleButtonClick}
              />
            )
          }
        </div>
      </Modal>
    )
  }
}


export default DialogModal
